import { Component } from '@theme/component';

/**
 * @typedef {object} Refs
 * @property {HTMLSelectElement} select – The select element with document options
 * @property {HTMLAnchorElement} cta – The "download" cta that links to the pdf
 *
 * @extends Component<Refs>
 */
export class ProductDocsComponent extends Component {
  requiredRefs = ['select', 'cta'];

  connectedCallback() {
    super.connectedCallback();
    const { select } = this.refs;
    if (select) {
      select.addEventListener('change', this.#updateCta.bind(this));
    }
  }

  disconnectedCallback() {}

  #updateCta() {
    const { cta, select } = this.refs;
    if (cta) {
      cta.href = select.value;
    }
  }
}

if (!customElements.get('product-docs')) {
  customElements.define('product-docs', ProductDocsComponent);
}
